"use client";

import * as React from "react";
import { cn } from "../../../utils";

export interface CellEmptyProps {
  className?: string;
}

/**
 * Never-run cell — em-dash placeholder. Visually distinct from
 * `CellNotFound` ("we ran and got nothing") and `CellLoading` ("we're
 * running right now").
 */
export function CellEmpty({ className }: CellEmptyProps) {
  return (
    <span
      className={cn("inline-flex items-center text-sm text-muted-foreground", className)}
      aria-label="No value"
    >
      {"—"}
    </span>
  );
}
